import { differenceInMinutes, format, formatDistanceStrict, isSameYear } from 'date-fns';
import { safeFromUnixTime } from './dates';

export const COUNTDOWN_CUTOFF_DAYS_IN_MINUTES = 10080; // 7 days

export const showCountDownBasedOnMinimumDate = (saleStartTs: number) => {
    const now = new Date();
    const upcoming = safeFromUnixTime(saleStartTs);
    const totalDays = differenceInMinutes(upcoming, now);

    return totalDays <= COUNTDOWN_CUTOFF_DAYS_IN_MINUTES;
};

export const getCountDown = (auctionTs: number, forceYear: boolean = false) => {
    const now = new Date();
    const upcoming = safeFromUnixTime(auctionTs);
    let countDown = false;

    let dateFormat =
        isSameYear(now, upcoming) && !forceYear ? format(upcoming, 'MMM dd') : format(upcoming, 'MMM dd, yyyy');

    const totalMinutesUntil = differenceInMinutes(upcoming, now);
    if (totalMinutesUntil > 0 && totalMinutesUntil <= COUNTDOWN_CUTOFF_DAYS_IN_MINUTES) {
        // date-fns has no option for abbreviations so we'll do it here
        dateFormat = formatDistanceStrict(now, upcoming);
        dateFormat = dateFormat
            .replace('hours', 'hrs')
            .replace('hour', 'hr')
            .replace('minutes', 'mins')
            .replace('minute', 'min');
        countDown = true;
    }

    return {
        countDown,
        dateFormat,
    };
};
